enum ActionType {
    UserLogin = 0x001,
    UserLogout = 0x002,
    UserRegistration = 0x004,
    UserRegistrationConfirmation = 0x008,
    UserDeactivation = 0x010,
    UserSelfDeactivation = 0x020,
    SendMessage = 0x040,
    ChangeInfoType = 0x080,
    ChangeNotificationType = 0x100,
    AddStation = 0x200,
    ChangeStation = 0x400,
    AddBoundryValues = 0x800,
    ChangeBoundryValues = 0x1000,
    AddCulture = 0x2000,
    DeleteCulture = 0x4000,
    UploadEducationDocument = 0x8000,
    RemoveEducationDocument = 0x10000,
    ChangeModuleName = 0x20000,
    UserActivation = 0x40000,
    ChangeSubscription = 0x80000,
    EditedEducationDocument = 0x100000,
    AddRecord = 0x200000,
    ChangeRecord = 0x400000,
    DeleteRecord = 0x800000,
    ChangeEntity = 0x1000000,
    AddAlarmGroup = 0x2000000,
    ChangeAlarmGroup = 0x4000000,
    DeleteAlarmGroup = 0x8000000,
}

export const actionTypes: Record<string, { value: number; label: string }> = {
    UserLogin: { value: ActionType.UserLogin, label: "Prijava korisnika" },
    UserLogout: { value: ActionType.UserLogout, label: "Odjava korisnika" },
    UserRegistration: { value: ActionType.UserRegistration, label: "Registracija korisnika" },
    UserRegistrationConfirmation: {
        value: ActionType.UserRegistrationConfirmation,
        label: "Potvrda registracije korisnika",
    },
    UserDeactivation: { value: ActionType.UserDeactivation, label: "Deaktivacija korisnika" },
    UserSelfDeactivation: {
        value: ActionType.UserSelfDeactivation,
        label: "Samo-deaktivacija korisnika",
    },
    SendMessage: { value: ActionType.SendMessage, label: "Slanje poruke" },
    ChangeInfoType: {
        value: ActionType.ChangeInfoType,
        label: "Promjena predbilježbe",
    },
    ChangeNotificationType: {
        value: ActionType.ChangeNotificationType,
        label: "Promjena načina obavještavanja",
    },
    AddStation: {
        value: ActionType.AddStation,
        label: "Unos stanice",
    },
    ChangeStation: {
        value: ActionType.ChangeStation,
        label: "Promjena stanice",
    },
    ChangeBoundryValues: {
        value: ActionType.ChangeBoundryValues,
        label: "Promjena graničnih vrijednosti",
    },
    AddCulture: { value: ActionType.AddCulture, label: "Unos kulture" },
    UploadDocument: {
        value: ActionType.UploadEducationDocument,
        label: "Stvoren dokument edukacije",
    },
    DeactivateDocument: {
        value: ActionType.RemoveEducationDocument,
        label: "Izbrisan dokument edukacije",
    },
    ChangeModuleName: {
        value: ActionType.ChangeModuleName,
        label: "Promjena modula",
    },
    UserActivation: {
        value: ActionType.UserActivation,
        label: "Aktivacija korisnika",
    },
    ChangeSubscription: {
        value: ActionType.ChangeSubscription,
        label: "Promjena pretplate na stručna područja",
    },
    EditedEducationDocument: {
        value: ActionType.EditedEducationDocument,
        label: "Uređen dokument edukacije",
    },
    AddRecord: {
        value: ActionType.AddRecord,
        label: "Unos evidencije" 
    },
    ChangeRecord: {
        value: ActionType.ChangeRecord,
        label: "Promjena evidencije"
    },
    DeleteRecord: {
        value: ActionType.DeleteRecord,
        label: "Brisanje evidencije"
    },
    ChangeEntity: {
        value: ActionType.ChangeEntity,
        label: "Promjena subjekta"
    },
    AddAlarmGroup: {
        value: ActionType.AddAlarmGroup,
        label: "Unos grupe alarma"
    },
    ChangeAlarmGroup: {
        value: ActionType.ChangeAlarmGroup,
        label: "Promjena grupe alarma"
    },
    DeleteAlarmGroup: {
        value: ActionType.DeleteAlarmGroup,
        label: "Brisanje grupe alarma"
    },
};
